import React, { useEffect, useState, useRef } from "react";
import { Input, Button } from "reactstrap";
import { ISearchingInputProps } from "./~types/SearchingInputProps";

import "./SearchingInput.css";

const SearchingInput = (props: ISearchingInputProps) => {
    const [searchString, setSearchString] = useState(props.value);
    const [isSearching, setIsSearching] = useState(false);
    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        setIsSearching(!!searchString?.trim());
    }, [searchString]);

    useEffect(() => {
        if (containerRef?.current) {
            (containerRef.current.firstElementChild as HTMLDivElement)?.focus();
            // const input = containerRef.current.querySelector<HTMLInputElement>('input');
            // input?.focus();
        }
    }, [containerRef]);

    const closeSearch = () => {
        if (!isSearching) {
            props.onSearch?.(searchString);
            setIsSearching(true);
        } else {
            props.onSearch?.("");
            setSearchString("");
            setIsSearching(false);
        }
    };

    const closeSearchKeyUp = (
        event: React.KeyboardEvent<HTMLButtonElement>
    ) => {
        if (event.key === "Enter") {
            closeSearch();
        }
    };

    return (
        <div
            ref={containerRef}
            className={props.className + " searching-input-container"}
        >
            <Input
                className="searching-input-container__input"
                type="text"
                multiple={false}
                value={searchString}
                placeholder={props.placeholder}
                onChange={(event) => setSearchString(event.target.value)}
                onKeyDown={(event) => {
                    if (event.key === "Enter") {
                        props.onSearch?.(searchString);
                        setIsSearching(true);
                    }
                }}
            />
            {isSearching ? (
                <Button
                    className="searching-input-container__btn-search"
                    onClick={closeSearch}
                    onKeyUp={closeSearchKeyUp}
                    tabIndex={0}
                >
                    {isSearching && searchString ? (
                        <i className="material-icons">clear</i>
                    ) : null}
                </Button>
            ) : null}
        </div>
    );
};

export default SearchingInput;
